import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Config } from '../config';

export class VrmLangTranslationLoader implements TranslateLoader {
  constructor(private httpClient: HttpClient) {}

  getTranslation(lang: string): Observable<any> {
    return this.httpClient.get(`${Config.languageAssetCdnRoot}${lang}.json?34787329842`, {
      headers: new HttpHeaders({
        'ngsw-bypass': 'true',
      }),
    });
  }
}
